import { getDistance, getDistanceInKM } from "./locationUtils"

const defaultStoryItem = {
  hero: false,
  overlay: false,
  loading: false,
  final: false,
  overlayColor: "text-white",
  title: "",
  body: "",
  rotate: false,
  small: false,
  layers: [],
  points: [],
  lines: [],
  serviceArea: [],
  showTotalScore: false,
  showPageWeightScore: false,
  showPerformanceScore: false,
  showHostingScore: false,
}

function interpolate(value, s1, s2, t1, t2, slope) {
  //Default to linear interpolation
  slope = slope || 0.5

  //If the value is out of the source range, floor to min/max target values
  if (value < Math.min(s1, s2)) {
    return Math.min(s1, s2) === s1 ? t1 : t2
  }

  if (value > Math.max(s1, s2)) {
    return Math.max(s1, s2) === s1 ? t1 : t2
  }

  //Reverse the value, to make it correspond to the target range (this is a side-effect of the bezier calculation)
  value = s2 - value

  var C1 = { x: s1, y: t1 } //Start of bezier curve
  var C3 = { x: s2, y: t2 } //End of bezier curve
  var C2 = {
    //Control point
    x: C3.x,
    y: C1.y + Math.abs(slope) * (C3.y - C1.y),
  }

  //Find out how far the value is on the curve
  var percent = value / (C3.x - C1.x)

  function b1(t) {
    return t * t
  }
  function b2(t) {
    return 2 * t * (1 - t)
  }
  function b3(t) {
    return (1 - t) * (1 - t)
  }

  return C1.y * b1(percent) + C2.y * b2(percent) + C3.y * b3(percent)
}

// zoom 1: 20k x 20k
// zoom 15: 25m x 25m
function computeZoom(dist, overhead = 0.9) {
  return Math.floor(
    interpolate((dist * (1 + overhead)) / 6371, 0, 1, 13.5, 1, 8)
  )
}

/*

c02: 12.966642379760742
cdnLocations: (67) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
cdnProvider: "Fastly"
city: "PALM SPRINGS"
greenData:
  green: true
  hosted_by: "Firebase Hosting"
  hosted_by_id: 861
  hosted_by_website: "firebase.google.com"
  modified: "2022-01-20T23:05:22"
  partner: null
  supporting_documents: []
  url: "sld.codes"
ipInfo:
  as: "AS54113 Fastly"
  city: "Montreal"
  country: "Canada"
  countryCode: "CA"
  isp: "Fastly"
  lat: 45.5017
  lon: -73.5673
  org: "Fastly"
  query: "199.232.194.22"
  region: "QC"
  regionName: "Quebec"
  status: "success"
  timezone: "America/Toronto"
  zip: "H4X"
lighthouse:
  audits: {efficient-animated-content: {…}, unminified-css: {…}, unused-javascript: {…}, server-response-time: {…}, network-requests: {…}, …}
  lighthouseVersion: "9.4.0"
  requestedUrl: "https://sld.codes/"
  score: 0.69
  stackPacks: [{…}]
  timing: 8131.2300000000005
name: "Homepage"
networkLatency: 1803
owner: "UZIZtf9MnSV0uwne9WRsIJ5gUAz2"
serviceArea:
  approxDistance: 13.09761856541489
  messages: []
  saPolygons: {fieldAliases: {…}, geometryType: 'esriGeometryPolygon', spatialReference: {…}, features: Array(1)}
timestamp: 1646772689348
url: "sld.codes"
isISPLocation
userInfo:
  as: "AS395148 Pacific Lightwave, Inc."
  city: "Azusa"
  country: "United States"
  countryCode: "US"
  ip: "8.34.116.185"
  isp: "Pacific Lightwave, Inc."
  lat: 34.123
  lon: -117.8988
  org: "Level 3"
  query: "8.34.116.185"
  region: "CA"
  regionName: "California"
  status: "success"
  timezone: "America/Los_Angeles"
  ua:
    browser: {name: 'Chrome', version: '97.0.4692.99', major: '97'}
    cpu: {}
    device: {}
    engine: {name: 'Blink', version: '97.0.4692.99'}
    os: {name: 'Mac OS', version: '10.15.7'}
    ua: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/97.0.4692.99 Safari/537.36"
zip: "91702"
*/

const StoryCreator = story => {
  console.log(story)
  let storyItems = []
  // const { networkLatency } = data.requestData
  // const { cdnProvider, cdnLocations } = data.cdnInfo
  // const { city, isp } = data.userInfo
  // const {
  //   hosted_by,
  //   green,
  //   url,
  //   data: greenData,
  // } = data.environmentalData.greenWebFoundation
  // const { saPolygons, approxDistance } = data.serviceArea
  // const { totalSize } = data.performance
  // const { hosting, pageWeight, performance } = data.auditScores

  ////////// PART 1: Story Introduction //////////
  if (story.userInfo && story.url) {
    if (story.isISPLocation) {
      storyItems.push({
        ...defaultStoryItem,
        title: "It all starts with you.",
        body: `Your request to ${story.url} started from your ${
          story.userInfo?.ua?.device || "device"
        } and was routed via your ISP - ${story.userInfo.isp} in ${
          story.userInfo.city
        }.`,
        goTo: {
          target: [story.userInfo.lon, story.userInfo.lat],
          zoom: 5,
          duration: 2000,
        },
        points: [
          { latitude: story.userInfo.lat, longitude: story.userInfo.lon },
        ],
      })
    } else {
      const ISPDistance = getDistanceInKM(story.userInfo, story.clientInfo)
      storyItems.push({
        ...defaultStoryItem,
        title: "It all starts with you.",
        body: `Your request to ${story?.url} started with you in ${
          story.userInfo.city
        }. Your request was routed via your ISP - ${
          story.userInfo.isp
        }. This distance is equivalent to ${Math.floor(
          (ISPDistance * 1000) / 50
        )} olympic-sized swimming pools end-to-end.`,
        goTo: {
          target: [story.userInfo.lon, story.userInfo.lat],
          zoom: computeZoom(ISPDistance),
          duration: 2000,
        },
        points: [
          { latitude: story.userInfo.lat, longitude: story.userInfo.lon },
          { latitude: story.clientInfo.lat, longitude: story.clientInfo.lon },
        ],
        lines: [
          {
            start: {
              latitude: story.userInfo.lat,
              longitude: story.userInfo.lon,
            },
            end: {
              latitude: story.clientInfo.lat,
              longitude: story.clientInfo.lon,
            },
          },
        ],
      })
    }
  } else {
    return []
  }

  if (story.cdnProvider && story.cdnLocations) {
    if (story.cdnProvider !== "UNKNOWN") {
      const CDNDistance = getDistanceInKM(story.userInfo, story.ipInfo)
      storyItems.push({
        ...defaultStoryItem,
        title: `Routed through ${story.cdnProvider}'s CDN`,
        body: `Your request was then fulfilled by a Content Delivery Network (CDN) owned by ${
          story.cdnProvider
        } who sit in front of ${story.url}. It takes the network ${
          story.networkLatency
        }ms to make the ${Math.floor(
          CDNDistance
        )}km journey there and back. It would take you ${Math.floor(
          CDNDistance / 5
        )} hours to walk that far!`,
        goTo: {
          target: [story.ipInfo.lon, story.ipInfo.lat],
          zoom: computeZoom(CDNDistance),
          duration: 2000,
        },
        points: [
          { latitude: story.userInfo.lat, longitude: story.userInfo.lon },
          { latitude: story.ipInfo.lat, longitude: story.ipInfo.lon },
        ],
        lines: [
          {
            start: {
              latitude: story.userInfo.lat,
              longitude: story.userInfo.lon,
            },
            end: {
              latitude: story.ipInfo.lat,
              longitude: story.ipInfo.lon,
            },
          },
        ],
      })
      storyItems.push({
        ...defaultStoryItem,
        title: "The CDN Network",
        body: `${story.cdnProvider} has servers in ${story.cdnLocations.length} locations around the globe serving requests every second.`,
        goTo: {
          target: [story.ipInfo.lon, story.ipInfo.lat],
          zoom: 3,
          duration:
            15 * (1 / getDistance(story.userInfo, story.ipInfo)) - 3 < 1
              ? 100
              : 2000,
        },
        rotate: true,
        points: story.cdnLocations.map(item => ({
          latitude: item.lat,
          longitude: item.lon,
        })),
      })
    } else {
      storyItems.push({
        ...defaultStoryItem,
        title: "CDN Networks",
        body: `While we couldn't find this sites exact Content Delivery Network (CDN), Akamai is a great example. Akamai has servers in ${story.exampleCdnLoc.length} locations around the globe serving requests every second.`,
        goTo: {
          target: [story.ipInfo.lon, story.ipInfo.lat],
          zoom: 3,
          duration:
            15 * (1 / getDistance(story.userInfo, story.ipInfo)) - 3 < 1
              ? 100
              : 2000,
        },
        rotate: false,
        points: story.exampleCdnLoc.map(item => ({
          latitude: item.lat,
          longitude: item.lon,
        })),
      })
    }
  } else {
    return [...storyItems, { loading: true }]
  }

  // ////////// PART 4: Analysis specific to individual //////////
  if (story.lighthouse) {
    const totalSize =
      story.lighthouse.audits.diagnostics.details.items[0].totalByteWeight /
      1024 /
      1024
    const carbon = (totalSize * 10).toFixed(2)
    storyItems.push({
      ...defaultStoryItem,
      hero: true,
      title: `Each visit produces ${carbon}g of CO2`,
      body: `sending ${totalSize.toFixed(2)} MB of data. Every time.`,
      rotate: true,
      goTo: {
        zoom: 1,
        duration: 2000,
      },
    })
  } else {
    return [...storyItems, { loading: true }]
  }
  if (story.serviceArea) {
    const totalSize =
      story.lighthouse.audits.diagnostics.details.items[0].totalByteWeight /
      1024 /
      1024
    const carbon = (totalSize * 10).toFixed(2)
    const { saPolygons, approxDistance } = story.serviceArea
    storyItems.push({
      ...defaultStoryItem,
      title: `${carbon}g of carbon`,
      body: `You could travel this far by car and release the same amount if you visit this website 100 times.`,
      serviceArea: saPolygons,
      goTo: {
        target: [
          parseFloat(
            story.clientInfo.lon ? story.clientInfo.lon : story.userInfo.lon
          ),
          parseFloat(
            story.clientInfo.lat ? story.clientInfo.lat : story.userInfo.lat
          ),
        ],
        zoom: computeZoom(approxDistance, 0.3),
        duration: 2000,
      },
    })
  } else {
    return [...storyItems, { loading: true }]
  }
  if (story.exampleCdnLoc) {
    storyItems.push({
      ...defaultStoryItem,
      hero: true,
      title: "But it's not just you.",
      body: `Millions of requests are made every second to over 1.8 billion websites.`,
      rotate: false,
      goTo: {
        target: [51.5074, 0.1278],
        zoom: 1,
        duration: 2000,
      },
      points: story.exampleCdnLoc.map(item => ({
        latitude: item.lat,
        longitude: item.lon,
      })),
      lines: story.exampleCdnLoc
        .map((item, index) => {
          if (index <= story.exampleCdnLoc.length - 3 && index % 2 === 0) {
            return {
              color: [245, 158, 11, 0.6],
              start: { latitude: item.lat, longitude: item.lon },
              end: {
                latitude: story.exampleCdnLoc[index + 2].lat,
                longitude: story.exampleCdnLoc[index + 2].lon,
              },
            }
          }
          return null
        })
        .filter(item => item !== null),
    })
  } else {
    return [...storyItems, { loading: true }]
  }
  storyItems.push({
    ...defaultStoryItem,
    title:
      "This map shows the CO2 emissions per capita by country. Every single request to a website produces CO2 - producing more combined emissions than all countries except the US and China, more than the entire airline industry anually and almost as much as the production and inciniration of plastic.",
    rotate: true,
    layers: ["CO2"],
  })
  storyItems.push({
    ...defaultStoryItem,
    hero: true,
    title: "So what can we do?",
    rotate: true,
  })
  if (story.greenData) {
    const { green, hosted_by } = story.greenData
    const { hosting } = story.auditScores
    if (green) {
      storyItems.push({
        ...defaultStoryItem,
        hero: true,
        small: true,
        showHostingScore: hosting + "",
        title: `${story.url} is hosted by a green hosting provider.`,
        body: `This URL is hosted on ${hosted_by}, which the Green Web Foundation considers green.`,
        rotate: true,
      })
    } else {
      if (story.greenData === false) {
        storyItems.push({
          ...defaultStoryItem,
          hero: true,
          small: true,
          showHostingScore: hosting + "",
          title: `${story.url}'s hosting could not be identified as green.`,
          body: `We were not able to identify whether this ${story.url}'s hosting is green. Switching to a green hosting provider would be a great start if you are not already using one.`,
          rotate: true,
        })
      } else {
        storyItems.push({
          ...defaultStoryItem,
          hero: true,
          small: true,
          showHostingScore: hosting + "",
          title: `${story.url}'s hosting could be greener.`,
          body: hosted_by
            ? `This URL is hosted on ${hosted_by}, which the Green Web Foundation considers not to be green. Switching to a green hosting provider would be a great start.`
            : `The Green Web Foundation considers the hosting provider of ${story.url} not to be green. Switching to a green hosting provider would be a great start.`,
          rotate: true,
        })
      }
    }
  } else {
    return [...storyItems, { loading: true }]
  }
  if (typeof story?.auditScores?.performance !== "undefined") {
    const { performance, hosting } = story.auditScores
    let perfBodyText = ""
    switch (performance) {
      case 0:
      case 1:
        perfBodyText = `${story.url} achieved a below average performance score. Improving this websites performance could significantly reduce its carbon footprint.`
        break
      case 2:
        perfBodyText = `${story.url} achieved an average performance score. Any steps taken to further improve this sites could significantly reduce your carbon footprint and improve user experience with faster load times.`
        break
      case 3:
        perfBodyText = `${story.url} achieved an excellent performance score. This means that the site loads quickly and is efficient!`
        break
      default:
        console.error("received invalid performance score")
        perfBodyText = `A performance score could not be computed for this website.`
        break
    }
    storyItems.push({
      ...defaultStoryItem,
      hero: true,
      small: true,
      showHostingScore: hosting + "",
      showPerformanceScore: performance + "",
      title: `${story.url} achieves a ${performance}/3 performance score.`,
      body: perfBodyText,
      rotate: true,
    })
  } else {
    return [...storyItems, { loading: true }]
  }
  if (typeof story?.auditScores?.pageWeight !== "undefined") {
    const { pageWeight, hosting, performance } = story.auditScores
    let pageSizeText = ""
    switch (pageWeight) {
      case 3:
        pageSizeText = `${story.url} has a small page weight!`
        break
      case 2:
        pageSizeText = `${story.url} has an above average page weight. This suggests that there is potentially some unoptimized JavaScript or multimedia content.`
        break
      case 1:
        pageSizeText = `${story.url} has a heavy page weight. This suggests that there is potentially a lot of unoptimized JavaScript or multimedia content.`
        break
      default:
        pageSizeText = `${story.url} has a very heavy page weight and produces more than double the CO2 produced by the average site. This suggests you may have a lot of unoptimized JavaScript or multimedia content.`
        break
    }
    storyItems.push({
      ...defaultStoryItem,
      hero: true,
      small: true,
      showHostingScore: hosting + "",
      showPerformanceScore: performance + "",
      showPageWeightScore: pageWeight + "",
      title: `${story.url} achieves a ${pageWeight}/3 page weight score.`,
      body: `${pageSizeText}. The smaller you can make your page weight the less energy required to transfer it so try and keep it small.`,
      rotate: true,
      final: true,
    })
  } else {
    return [...storyItems, { loading: true }]
  }

  return storyItems
}

export default StoryCreator
